const initialState = {
  dashboard: {
    locationData: [],
  },
  inventory: {
    locationData: [],
  },
  deviceup: {
    locationData: [],
  },
  devicedown: {
    locationData: [],
  },
  inactive: {
    locationData: [],
  },
  overview: {
    locationData: [],
  },
  clientdevice: {
    locationData: [],
  },
  unknowndevice: {
    locationData: [],
  },
  changeevent: {
    locationData: [],
  },
  cmdbinventory: {
    locationData: [],
  },
  alertupdown: {
    locationData: [],
  },
  cmdbscanevent: {
    locationData: [],
  },
  cmdbchangeevent: {
    locationData: [],
  },
  globalmap: {
    locationData: [],
  },
  health: {
    locationData: [],
  },
  sitewisehealth: {
    locationData: [],
  },
  sitewise: {
    locationData: [],
  },
 
};

const locationSelectReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SET_LOCATION_OPTIONS':
      return {
        ...state,
        [action.payload.page]: {
          locationData: action.payload.location_uuid,
          leLocationData: action.payload.le_location_uuid
        },
      };
    

    default:
      return state;
  }
};




export default locationSelectReducer;


// const initialState = {
//   dashboard: {
//     locationData: [],
//   },
//   inventory: {
//     locationData: [],
//   },
//   deviceup: {
//     locationData: [],
//   },
//   devicedown: {
//     locationData: [],
//   },
//   inactive: {
//     locationData: [],
//   },
//   overview: {
//     locationData: [],
//   },
//   clientdevice: {
//     locationData: [],
//   },
//   unknowndevice: {
//     locationData: [],
//   },
//   changeevent: {
//     locationData: [],
//   },
//   cmdbinventory: {
//     locationData: [],
//   },
//   alertupdown: {
//     locationData: [],
//   },
//   cmdbscanevent: {
//     locationData: [],
//   },
//   cmdbchangeevent: {
//     locationData: [],
//   },
//   globalmap: {
//     locationData: [],
//   },
//   health: {
//     locationData: [],
//   },
//   sitewisehealth: {
//     locationData: [],
//   },
//   sitewise: {
//     locationData: [],
//   },
//   // currentIndex: 0
// };

// const locationSelectReducer = (state = initialState, action = {}) => {
//   switch (action.type) {
//     case 'SET_LOCATION_OPTIONS':
//       return {
//         ...state,
//         [action.payload.section]: {
//           ...state[action.payload.section],
//           locationData: action.payload.locationData
//         }
//       };

//     // case 'SET_INDEX':
//     //   return {
//     //     ...state,
//     //     currentIndex: action.payload.currentIndex
//     //   };

//     default:
//       return state;
//   }
// };

// export default locationSelectReducer;



